import React, { useCallback, useEffect, useState, useRef } from "react";
import { useListFilters } from "../../helper/useListFilters";
import useRealtimeSync from "../../hooks/useRealtimeSync";
import { lastQuery } from "../../helper/lastQuery";
import ResponsiveDrawer from "../../component/sidebar/sidebar.component";
import { FontFamily } from "../../component/theme/fontFamily";
import { fontWeight } from "../../component/theme/fontWeight";
import { fontSize } from "../../component/theme/fontSize";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Switch,
  Tooltip,
  Typography,
  Chip,
} from "@mui/material";
import { ThemeColor } from "../../component/theme/color";
import dayjs from "dayjs";
import CustomButton from "../../component/button/button";
import CustomDataTable from "../../component/datatable/DataTable";
import OutlineCustomButton from "../../component/button/outlineButton";
import Settinglist from "../../Icon/Settinglist";
import { useNavigate } from "react-router-dom";
import { GetRoleAction, GetUserAction } from "../../Redux/action/SettingAction";
import { useDispatch, useSelector } from "react-redux";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import {
  EditUserBlockedStatusService,
  ResetUserPasswordService,
} from "../../Redux/service/SettingService";
import LockResetIcon from "@mui/icons-material/LockReset";
import { showSnackbar } from "../../Redux/action/SnackbarAction";
import ConfirmationModal from "../../component/Modal/ConfirmationModal/ConfirmationModal";
import { handleExport } from "../ExportFunction/ExportFunction";
import FilterComponent from "../../component/filterForTable/FilterComponent";
import { basicurl, token } from "../../Redux/ServiceUrl/url";
import axios from "axios";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { CustomPagination } from "../../component/datatable/CustomPagination";
import { BulkUploadModal } from "../../component/Modal/BulkUploadModal";
import { toTitleCase } from "../../helper/helper";
import GlobalSearch from "../../component/sidebar/globalSearch";

const UserlistPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [Userlist, setUserlist] = useState([]);

  const [table_load, setTable_load] = useState(false);
  const [isToggled, setIsToggled] = useState(false);
  const [selectionModel, setSelectionModel] = useState([]);
  const [confirmationopen, setConfirmationOpen] = useState(false);
  const [confirmationactiveopen, setConfirmationActiveOpen] = useState(false);
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [changeBlockStatusOfOrg, setChangeBlockStatusOfOrg] = useState({});
  const [data, setData] = useState([]);
  const [resetPasswordRow, setResetPasswordRow] = useState(null);
  const [resetPasswordConfirmationOpen, setResetPasswordConfirmationOpen] =
    useState(false);

  const [Rolelist, setRolelist] = useState([]);

  const [visibleColumns, setVisibleColumns] = useState([]);

  const [loading, setLoading] = useState(true);

  const [BulkModal, setBulkModal] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showUserAnchor, setShowUserAnchor] = React.useState(null);
  const openbulk = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleBulkClose = () => {
    setAnchorEl(null);
  };

  const handleShowUserClick = (event) => {
    setShowUserAnchor(event.currentTarget);
  };
  const handleShowUserClose = () => {
    setShowUserAnchor(null);
  };

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 50,
    hasNextPage: false,
    hasPrevPage: false,
  });

  const handlePageChange = (page) => {
    setTable_load(true);
    console.log(page);
    let data = {
      page: page,
      limit: limit,
    };
    reload(data);
    // fetchData(page, pagination.limit);
  };

  const [limit, setLimit] = useState(50);

  const handleLimitChange = (newLimit) => {
    setTable_load(true);
    setLimit(newLimit);

    reload({ page: 1, limit: newLimit });
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Hide the loader after 2 seconds
    }, 2000); // Simulate 2 seconds of loading time
  }, []);

  const handleVisibleColumnsChange = useCallback((visibleColumns) => {
    // Handle the change in visible columns
    setVisibleColumns(visibleColumns);
  }, []);

  const RolelistState = useSelector(
    (state) => state.setting?.role?.data?.roles
  );
  useEffect(() => {
    dispatch(GetRoleAction());
  }, []);

  const columns = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        const handleEditActionClick = (event) => {
          event.stopPropagation();
          navigate(`/CAE/EditUser/${params.row.id}`);
        };
        const handleResetPasswordClick = (event) => {
          event.stopPropagation();
          setResetPasswordRow(params.row);
          setResetPasswordConfirmationOpen(true);
        };
        return (
          <>
            <Tooltip title="Edit User">
              {" "}
              <IconButton onClick={handleEditActionClick}>
                <ModeEditIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Reset password and send it to the registered email">
              <IconButton onClick={handleResetPasswordClick}>
                <LockResetIcon sx={{ fill: ThemeColor.LIGHTPURPLE }} />
              </IconButton>
            </Tooltip>
          </>
        );
      },
    },
    {
      field: "firstName",
      headerName: "User First Name",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">{toTitleCase(params.row.firstName)}</div>
        );
      },
    },
    {
      field: "lastName",
      headerName: "User Last Name",
      width: 150,
      renderCell: (params) => {
        return <div className="d-flex">{toTitleCase(params.row.lastName)}</div>;
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "phone",
      headerName: "Phone",
      width: 150,
    },
    {
      field: "role",
      headerName: "Role",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex" style={{ color: ThemeColor.BLUE }}>
            {params.row?.roles.role?.split("_")?.map((r) => {
              return <div>{toTitleCase(r)} &nbsp;</div>;
            })}
            {/* {params.row.roles?.map((data, index) => {
              return (
                <div>
                  {data.title}
                  {index + 1 === params.row.roles?.length ? "" : ", "}
                </div>
              );
            })} */}
          </div>
        );
      },
    },
    {
      field: "birthday",
      headerName: "Birthday Date",
      width: 150,
      renderCell: (params) => {
        return (
          <div>{dayjs(params.row.birthday).format("YYYY-MM-DD HH:MM")}</div>
        );
      },
    },
    {
      field: "isActive",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        return (
          <div className="d-flex">
            {params.row?.isActive === "Y" ? "Active" : "In-active"}
          </div>
        );
      },
    },

    {
      field: "blocked",
      headerName: "User Status",
      width: 140,
      renderCell: (params) => {
        const handleBlockingStatusChange = async (e) => {
          console.log(e.target.checked);
          setUserlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id
                ? { ...data, isBlocked: data.isBlocked === "Y" ? "N" : "Y" }
                : data
            )
          );
          setConfirmationOpen(true);
          setChangeBlockStatusOfOrg({
            id: params.row.id,
            isBlocked: e.target.checked ? "Y" : "N",
          });
        };
        return (
          <>
            {window.sessionStorage.getItem("user_role_type") === "admin" && (
              <Tooltip title="Toggle block status for this user">
                <Box display="flex" alignItems="center" className="px-2">
                  <Chip
                    label={params.row.isBlocked === "Y" ? "Blocked" : "Active"}
                    clickable
                    color={params.row.isBlocked === "Y" ? "error" : "success"}
                    onClick={() => {
                      // prepare change and open confirmation
                      const newStatus = params.row.isBlocked === "Y" ? "N" : "Y";
                      setChangeBlockStatusOfOrg({ id: params.row.id, isBlocked: newStatus });
                      setConfirmationOpen(true);
                      // optimistic UI update
                      setUserlist((prev) =>
                        prev.map((data) =>
                          data.id === params.row.id
                            ? { ...data, isBlocked: newStatus }
                            : data
                        )
                      );
                    }}
                    sx={{ fontWeight: 600 }}
                  />
                </Box>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      field: "active",
      headerName: "",
      width: 150,
      renderCell: (params) => {
        const handleActiveActionClick = (event) => {
          event.stopPropagation();
          const newActiveValue = params.row.isActive === "Y" ? "N" : "Y";
          // optimistic update
          setUserlist((prev) =>
            prev.map((data) =>
              data.id === params.row.id ? { ...data, isActive: newActiveValue } : data
            )
          );
          setChangeBlockStatusOfOrg({ id: params.row.id, isActive: newActiveValue });
          setConfirmationActiveOpen(true);
        };

        if (window.sessionStorage.getItem("user_role_type") !== "admin") return null;

        const isActive = params.row.isActive === "Y";
        return (
          <Box display="flex" alignItems="center" className="px-2">
            <Button
              size="small"
              variant="contained"
              onClick={handleActiveActionClick}
              sx={{
                backgroundColor: isActive ? ThemeColor.RED : "#28a745",
                color: ThemeColor.WHITE,
                textTransform: "none",
                minWidth: 90,
                '&:hover': {
                  backgroundColor: isActive ? '#c92b27' : '#229a3f',
                },
              }}
            >
              {isActive ? "Deactivate" : "Activate"}
            </Button>
          </Box>
        );
      },
    },
  ];

  const UserlistState = useSelector((state) => state.setting?.user?.data);
  //(UserlistState, "User data");

  useEffect(() => {
    // console.log(UniversitylistState?.pagination)
    if (UserlistState) {
      // const { data, pagination } = UserlistState;
      // setRows(data);
      setPagination(UserlistState?.pagination);
    }
  }, [UserlistState]);

  useEffect(() => {
    dispatch({ type: "GetUserList", payload: null });
    setTable_load(true);
    let data = {
      page: 1,
      limit: 50,
    };
    reload(data);
  }, []);

  // Someone else (or another screen) added, updated or deleted a user:
  // reload exactly the view the user is looking at. Local edits go through the
  // same path, so the table is never stale.
  useRealtimeSync(
    "login",
    useCallback(() => {
      setTable_load(true);
      reload(lastQuery("user", { page: 1, limit: 50 }));
    }, [dispatch])
  );

  useEffect(() => {
    // Rows for a filtered view do not come from redux. Letting this run
    // would write the stale unfiltered list back over them - which is why
    // the filter survived a reload (redux is empty then) but not a Back.
    //
    // A later redux change means an action elsewhere refreshed the data
    // (a modal, an import), so the filtered view is fetched again instead.
    if (getFilters().length > 0) {
      if (reduxSyncedOnce.current) fetchData(getFilters());
      reduxSyncedOnce.current = true;
      return;
    }
    reduxSyncedOnce.current = true;
    if (isToggled) {
      setUserlist(
        UserlistState?.blockedUsers?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setUserlist(
        UserlistState?.activeUsers?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    if (UserlistState != undefined) setTable_load(false);
  }, [UserlistState]);

  // Handle toggle change
  const handleStatusChange = async () => {
    const newToggleState = !isToggled;
    if (newToggleState) {
      setUserlist(
        UserlistState?.blockedUsers?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    } else {
      setUserlist(
        UserlistState?.activeUsers?.map(({ _id, ...rest }) => ({
          id: _id,
          ...rest,
        }))
      );
    }
    setIsToggled(newToggleState);
  };

  const fields = [
    // { label: "Agent ID", value: "agentId", type: "select", option: Agentlist },
    {
      label: "User First Name",
      value: "firstName",
      type: "text",
      // option: Universitylist,
    },
    {
      label: "User last Name",
      value: "lastName",
      type: "text",
      // option: Universitylist,
    },
    {
      label: "Email",
      value: "email",
      type: "text",
      // option: Degreelist,
    },
    {
      label: "Roles",
      value: "roles",
      type: "multi-select",
      option: Rolelist,
    },
  ];
  const fetchData = async (filters) => {
    let string = filters.map((data) => `${data.field}=${data.value}`);
    try {
      let response = await axios.get(
        basicurl + `/api/login/get-all-active-users?${string.join("&")}&limit=${0}&page=${1}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // const result = await response.json();
      console.log(response);
      setPagination(response.data?.pagination)
      if (isToggled) {
        setUserlist(
          response.data?.blockedUsers?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      } else {
        setUserlist(
          response.data?.activeUsers?.map(({ _id, ...rest }) => ({
            id: _id,
            ...rest,
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching filtered data:", error);
    }
  };

  /**
   * Reload the rows.
   *
   * Every action on this page reloads through here so that a filter which
   * is on screen stays applied. Applying a filter used `fetchData` while
   * every action afterwards used the plain redux action, so the table went
   * back to showing everything while the panel still said a filter was on.
   *
   * The filters live in component state, so leaving the page and coming
   * back starts clean with the full list.
   */
  /** False until the first redux sync, so mounting does not fetch twice. */
  const reduxSyncedOnce = useRef(false);

  const { activeFilters, getFilters, applyFilters } = useListFilters(
    (filters) => fetchData(filters),
    () => dispatch(GetUserAction({ page: 1, limit: limit }))
  );

  const reload = (data) => {
    // Read through the ref: some of the callers below are memoised with
    // empty deps, so a captured value would be frozen as "no filters".
    const applied = getFilters();
    if (applied.length > 0) {
      fetchData(applied);
      return;
    }
    dispatch(GetUserAction(data));
  };

  const handleApplyFilters = applyFilters;
  const handleGetBulkTemplate = async () => {
    try {
      const response = await axios.get(
        `${basicurl}/api/login/cae-users/template`,
        {
          responseType: "blob", // 👈 VERY important for binary data like Excel
        }
      );

      // Create a blob from the response
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create a download link and click it
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "user_bulk.xlsx"; // 👈 you can set a dynamic filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      // Clean up the blob URL
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  return (
    <div>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            fontSize: "24px",
            color: "#007bff",
          }}
        >
          <div
            style={{
              position: "relative",
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "transparent",
            }}
          >
            <div style={{ width: "100%", height: "100%", justifyContent: "center", display: "flex", alignItems: "center" }}>
              <img
                src="/assest/Group.png" // Your image URL
                alt="Loading..."
                style={{ width: "75%", height: "75%", objectFit: "contain" }}
              />
            </div>

            <CircularProgress
              size={100}
              sx={{
                color: ThemeColor.NAVYBLUE, // Customize the loader color
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
              }}
            />
          </div>
        </div>
      ) : (
        <>
          <Grid container spacing={2} alignItems="center">
            <Grid item lg={3} md={3} xs={12}>
              <div className="d-flex align-items-center">
                <IconButton onClick={() => navigate(-1)}>
                  <ArrowBackIcon />
                </IconButton>
                <Typography
                  fontFamily={FontFamily.Poppins}
                  fontWeight={fontWeight.W600}
                  fontSize={fontSize.h2.small}
                >
                  User List
                </Typography>
              </div>
            </Grid>
            <Grid item lg={9} md={9} xs={12}>
              <Box
                className="d-flex align-items-center w-100"
                sx={{
                  justifyContent: {
                    xs: "flex-start",
                    sm: "flex-start",
                    md: "flex-end",
                  },
                  flexWrap: "wrap",
                  gap: 1.5,
                }}
              >
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() => setFilterOpen(true)}
                >
                  Filter
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="submit"
                  backgroundColor={ThemeColor.PURPLE}
                  onClick={() =>
                    handleExport(
                      selectionModel,
                      "User",
                      Userlist,
                      "isActive",
                      visibleColumns
                    )
                  }
                >
                  Export
                </OutlineCustomButton>
                <OutlineCustomButton
                  variant="contained"
                  type="button"
                  backgroundColor={ThemeColor.WHITE}
                  color={ThemeColor.BLACK}
                  onClick={handleShowUserClick}
                  sx={{ textTransform: 'none', px: 2 }}
                >
                  <Typography sx={{ fontSize: 14, fontWeight: 600, color: ThemeColor.BLACK }}>
                    User Status
                  </Typography>
                </OutlineCustomButton>
                <Menu
                  id="show-user-menu"
                  anchorEl={showUserAnchor}
                  open={Boolean(showUserAnchor)}
                  onClose={handleShowUserClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                >
                  <MenuItem
                    onClick={() => {
                      setUserlist(
                        UserlistState?.activeUsers?.map(({ _id, ...rest }) => ({ id: _id, ...rest }))
                      );
                      setIsToggled(false);
                      handleShowUserClose();
                    }}
                  >
                    <Chip label="Active" color="success" />
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setUserlist(
                        UserlistState?.blockedUsers?.map(({ _id, ...rest }) => ({ id: _id, ...rest }))
                      );
                      setIsToggled(true);
                      handleShowUserClose();
                    }}
                  >
                    <Chip label="Blocked" color="error" />
                  </MenuItem>
                </Menu>

                <CustomButton
                  variant="contained"
                  type="submit"
                  color={ThemeColor.WHITE}
                  onClick={handleClick}
                >
                  Bulk Update
                </CustomButton>
                <Menu
                  id="demo-positioned-menu"
                  aria-labelledby="demo-positioned-button"
                  anchorEl={anchorEl}
                  open={openbulk}
                  onClose={handleBulkClose}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  <MenuItem onClick={handleGetBulkTemplate}>
                    Download Template
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setBulkModal(!BulkModal);
                    }}
                  >
                    Upload Data (Bulk)
                  </MenuItem>
                </Menu>

                {(!window.sessionStorage.getItem("user_role_type") === "agent" ||
                  window.sessionStorage.getItem("user_role_type") === "admin" ||
                  !window.sessionStorage.getItem("user_role_type") === "user") && (
                  <CustomButton
                    variant="contained"
                    type="submit"
                    color={ThemeColor.WHITE}
                    onClick={() => navigate("/CAE/AddUser")}
                  >
                    Add User
                  </CustomButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <div className="table-container mt-4" style={{ overflowX: "hidden" }}>
            <CustomDataTable
              row={Userlist ? Userlist : []}
              columns={columns}
              loading={table_load}
              minTableWidth="100%"
              onSelectionChange={(newSelection) => {
                // console.log(newSelection)
                setSelectionModel(newSelection);
              }}
              getRowClassName={(params) =>
                params.row.isActive === "Y" ? "row-white" : "row-dull"
              }
              onVisibleColumnsChange={handleVisibleColumnsChange}
            />
          </div>
          <CustomPagination
            pagination={pagination}
            onPageChange={handlePageChange}
            limit={limit}
            onLimitChange={handleLimitChange}
          />
          <FilterComponent
            open={isFilterOpen}
            onClose={() => setFilterOpen(false)}
            onApply={handleApplyFilters}
            initialFilters={activeFilters}
            fields={fields}
          />
          <BulkUploadModal
            open={BulkModal}
            handleClose={() => {
              setBulkModal(!BulkModal);
            }}
            url={"api/login/cae-users/bulk-upload"}
            action={() => {
              let data = {
                limit: limit,
                page: 1,
              };
              reload(data);
            }}
          />
          <ConfirmationModal
            msg="Updated"
            btnName="Update"
            handleConfirmationClose={() => {
              setUserlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isBlocked:
                        changeBlockStatusOfOrg.isBlocked === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditUserBlockedStatusService(
                  changeBlockStatusOfOrg,
                  { isBlocked: changeBlockStatusOfOrg.isBlocked }
                );

                if (res.status === 200) {
                  let data = {
                    limit: 25,
                    page: 1,
                  };
                  reload(data);
                  setIsToggled(!isToggled); // Dispatch the action if success
                  // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationopen}
            message={"Want to change the blocking status?"}
          />

          <ConfirmationModal
            msg="Updated "
            btnName="Update"
            handleConfirmationClose={() => {
              setUserlist((prev) =>
                prev.map((data) =>
                  data.id === changeBlockStatusOfOrg.id
                    ? {
                      ...data,
                      isActive:
                        changeBlockStatusOfOrg.isActive === "Y" ? "N" : "Y",
                    }
                    : data
                )
              );
              setConfirmationActiveOpen(false);
            }}
            deletefunction={async () => {
              try {
                const res = await EditUserBlockedStatusService(
                  changeBlockStatusOfOrg,
                  { isActive: changeBlockStatusOfOrg.isActive }
                );
                console.log(res);

                if (res.status === 200) {
                  reload();
                  // setIsToggled(!isToggled); // Dispatch the action if success
                  return res; // Return the result so the child can access it
                } else {
                  return Promise.reject("Unexpected response status"); // Handle unexpected status codes
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={confirmationactiveopen}
            message={"Want to change the active status?"}
          />

          <ConfirmationModal
            msg="Password Reset"
            btnName="Reset"
            handleConfirmationClose={() => {
              setResetPasswordConfirmationOpen(false);
              setResetPasswordRow(null);
            }}
            deletefunction={async () => {
              try {
                const res = await ResetUserPasswordService(
                  resetPasswordRow?.id
                );

                if (res.status === 200) {
                  dispatch(
                    showSnackbar(
                      res.data?.message ||
                        "A new password has been sent to the registered email",
                      "success"
                    )
                  );
                  return res;
                } else {
                  return Promise.reject("Unexpected response status");
                }
              } catch (e) {
                dispatch(
                  showSnackbar(
                    e.response?.data?.message || "Error occurred",
                    "error"
                  )
                );
                return e;
              }
            }}
            confirmationopen={resetPasswordConfirmationOpen}
            message={`Reset the password for ${
              resetPasswordRow?.email || "this user"
            }? A new random password will be generated and emailed to them.`}
          />
        </>
      )}
    </div>
  );
};

function Userlist() {
  const dispatch = useDispatch();

  const handleSearch = (searchValue) => {
    console.log(searchValue);
    let data = {
      page: 1,
      limit: 50,
      search: searchValue,
    };

    dispatch(GetUserAction(data));
  };
  return (
    <div>
      <ResponsiveDrawer
        maincontent={<UserlistPage />}
        globalsearch={<GlobalSearch onSearch={handleSearch} />}
      />
    </div>
  );
}

export default Userlist;
